<template>
    <div class="device-type-manange relative">
        <!-- 表单开始 -->
        <el-row class="inputs mg-20" :gutter="20">
            <el-col :md="6" :lg="4" :xl="5" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">特属服务对象：</span>
                <el-input v-model="user_name" placeholder="特属服务对象模糊搜索"/>
            </el-col>
            <!--                <el-col :md="6" :lg="6" :xl="4">-->
            <!--                    <span class="fs-14 pd-r-10">特属服务对象电话：</span>-->
            <!--                    <el-input v-model="user_mobile" placeholder="特属服务对象电话模糊搜索"/>-->
            <!--                </el-col>-->
            <el-col :md="9" :lg="5" :xl="10" :sm="12" :xs="24" v-if="status == 3">
                <span class="fs-14 pd-r-10">完成会面时间：</span>
                <el-date-picker
                    v-model="search_book_date"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    @change="dateChange"
                ></el-date-picker>
            </el-col>
            <el-col :md="9" :lg="5" :xl="10" :sm="12" :xs="24" v-if="status == 4">
                <span class="fs-14 pd-r-10">中断会面时间：</span>
                <el-date-picker
                    v-model="search_book_date"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    @change="dateChange"
                ></el-date-picker>
            </el-col>
        </el-row>
        <el-row class="inputs mg-20" :gutter="20">
            <el-col :md="6" :lg="4" :xl="5" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">&ensp;&ensp;&ensp;&ensp;特属专家：</span>
                <el-input v-model="doctor_name" placeholder="特属专家模糊搜索"/>
            </el-col>
            <!--                <el-col :md="6" :lg="6" :xl="4">-->
            <!--                    <span class="fs-14 pd-r-10">特属专家电话：</span>-->
            <!--                    <el-input v-model="doctor_mobile" placeholder="特属专家电话模糊搜索"/>-->
            <!--                </el-col>-->
            <el-col :md="6" :lg="5" :xl="4" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">&ensp;&ensp;预约单类型：</span>
                <el-select v-model="status" @change="getList(1)" placeholder="请选择预约单类型" style="max-width: none !important; width: 100%;">
                    <el-option
                        v-for="item in allStatus"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-col>
            <el-col :md="9" :lg="4" :xl="10" :sm="12" :xs="24">
                <el-button @click="resetForm">重置</el-button>
                <el-button @click="search">筛选</el-button>
                <el-button type="primary" @click="exportExcel">导出数据</el-button>
            </el-col>
        </el-row>

        <!-- 表单结束 -->

        <el-table :data="tableData" border style="width: 100%">
            <el-table-column width="50" prop="no" label="序号" align="center"
                             label-class-name="label"></el-table-column>
            <el-table-column prop="user_name" label="特属服务对象" align="center" label-class-name="label"></el-table-column>
            <el-table-column  prop="doctor_name" label="特属专家" align="center" label-class-name="label"></el-table-column>
            <el-table-column  label="预约状态" align="center" label-class-name="label">
                <template slot-scope="scope">
                    <el-image :src="scope.row.status_name_icon" style="width:1rem;position: relative;top:10px;left:-3px"  fit="fill"/>
                    <span>{{scope.row.status_name}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="book_date" label="期望会面时间" align="center" label-class-name="label" v-if="status == 4"></el-table-column>
            <el-table-column  prop="last_meet_time" label="会面时间" align="center" label-class-name="label" v-if="status == 3"></el-table-column>
            <el-table-column  prop="update_date" label="中断会面时间" align="center" label-class-name="label" v-if="status == 4"></el-table-column>
            <el-table-column  prop="update_date" label="完成会面时间" align="center" label-class-name="label" v-if="status == 3"></el-table-column>

        </el-table>
        <el-pagination
            class="mg-20 ta-r"
            background
            layout="total, sizes, prev, pager, next, jumper"
            :page-sizes="[10, 25, 50, 100]"
            :total="total"
            :page-size="perpage"
            :current-page="page"
            @current-change="changePage"
            @size-change="changeSite"
        ></el-pagination>
    </div>
</template>
<script>
import {getUserInfos} from '@/utils/userInfos'
import {getFormatDate} from "@/utils/date";
import {check} from "@/utils/checkData";
import {authUrlCheck, isMobile} from "@/api/order";
import {export2Excel} from "@/utils/excel";

export default {
    data() {
        return {
            role_id: 0,
            page: 1,
            perpage: 10,
            total: 0,
            status: 3,
            user_name: '',
            user_mobile: '',
            doctor_name: '',
            doctor_mobile: '',
            search_book_date: '',
            start_book_date: '',
            end_book_date: '',
            reservationing_number: 0,
            reservationed_number: 0,
            reservationed_success_number: 0,
            reservationed_faile_number: 0,
            allType: [],
            tableData: [],
            allStatus: [
                {
                    id: 3,
                    name: '会面完成'
                },
                {
                    id: 4,
                    name: '会面中断'
                },
            ],
            is_mobile: false,
        };
    },
    created() {
        if (isMobile()) {
            this.is_mobile = true
        }
    },
    mounted() {
        let userInfo = getUserInfos()
        if (userInfo) {
            this.role_id = parseInt(userInfo.role_id)
        }
        this.getList();
        localStorage.setItem('prev_page', 'renewalcontract_list')
    },
    methods: {

        // 预约列表
        getList(is_change = 0) {
            if (is_change) {
                this.page = 1
            }
            let params = {
                servername: 'Ruyi_AdminWorkbenchServices',
                method: 'listing',
                params: {
                    user_name: this.user_name,
                    user_mobile: this.user_mobile,
                    doctor_name: this.doctor_name,
                    doctor_mobile: this.doctor_mobile,
                    start_book_date: this.start_book_date,
                    end_book_date: this.end_book_date,
                    is_renewal: 1,
                    status: this.status,
                },
                pageinfo: {
                    page: this.page,
                    perpage: this.perpage,
                }
            };

            this.$api.service(params).then(res => {
                if (!check(res)) {
                    this.tableData = [];
                    this.total = 0;
                    return;
                }
                let list = res.data.data.list
                for (var i = 0; i < list.length; i++) {
                    // 以序号代替ID
                    list[i].no = (this.page - 1) * this.perpage + i + 1
                    if (!list[i].meet_date) {
                        list[i].last_meet_time = (list[i].status > 2) ? '无' : '待定';
                    } else {
                        list[i].last_meet_time = list[i].meet_date + ' ' + list[i].meet_time;
                    }
                    if (list[i].address_id < 1) {
                        list[i].address_info = (list[i].status > 2) ? '无' : '待定';
                    } else {
                        list[i].address_info = list[i].region_name + list[i].address;
                    }
                    list[i].book_date = `${list[i].book_date} ${list[i].half}`

                    switch (list[i].status) {
                        case '1':
                            list[i].status_name = '预约处理';
                            list[i].status_name_icon = require('@/assets/icon_reservation.png');
                            list[i].isShowHandle = 1;
                            break;
                        case '2':
                            list[i].status_name = '等待会面';
                            list[i].status_name_icon = require('@/assets/icon_success.png');
                            list[i].isShowHandle = 1;
                            break;
                        case '3':
                            list[i].status_name = '会面完成';
                            list[i].status_name_icon = require('@/assets/icon_success.png');
                            list[i].isShowHandle = 0;
                            break;
                        case '4':
                            list[i].status_name = '会面中断';
                            list[i].status_name_icon = require('@/assets/icon_cancel.png');
                            list[i].isShowHandle = 0;
                            break;

                    }
                }




                this.tableData = res.data.data.list;
                this.total = res.data.data.page.count;
                if(this.status==1)
                {
                    this.$store.commit("websocket/SET_MESSAGE","22");
                }


            });


        },

        // 改变每页条数
        changeSite(index) {
            this.perpage = index;
            this.getList();
        },

        //更换页码
        changePage(index) {
            this.page = index;
            this.getList();
        },


        // 跳转添加页
        addHospitalType() {
            this.$router.push({name: "articleAdd", params: {}});
        },

        // 重置按钮
        resetForm() {
            this.user_name = "";
            this.user_mobile = "";
            this.doctor_name = "";
            this.doctor_mobile = "";
            this.start_book_date = "";
            this.end_book_date = "";
            this.search_book_date = "";
            this.status = 3;
            this.page = 1;
            this.getList();
        },
        dateChange(e){
            if (!e) {
                this.search_book_date = null
                this.start_book_date = ''
                this.end_book_date = ''
            }
        },
        // 搜索
        search() {
            if (this.search_book_date) {
                this.start_book_date = this.search_book_date[0];
                this.end_book_date = this.search_book_date[1];
            }
            this.page = 1;
            this.getList();
        },

        searchStatus(status) {
            this.status = status;
            this.page = 1;
            this.getList();
        },

        getAllData() {
            this.resetForm();
        },
        getTimeState(){
            // 获取当前时间
            let timeNow = new Date();
            // 获取当前小时
            let hours = timeNow.getHours();
            // 设置默认文字
            let state= ``;
            // 判断当前时间段
            if (hours >= 0 && hours <= 12) {
                state = `早安`;
            } else if (hours > 12 && hours <= 18) {
                state = `午安`;
            } else if (hours > 18 && hours <= 24) {
                state= `晚安`;
            }
            return state;
        },
        // 导出数据
        exportExcel() {
            let params = {
                servername: 'Ruyi_AdminWorkbenchServices',
                method: 'listing',
                params: {
                    user_name: this.user_name,
                    user_mobile: this.user_mobile,
                    doctor_name: this.doctor_name,
                    doctor_mobile: this.doctor_mobile,
                    start_book_date: this.start_book_date,
                    end_book_date: this.end_book_date,
                    status: this.status,
                },
            };

            let colums_list = [
                {title: "特属服务对象姓名", key: "user_name"},
                {title: "特属专家姓名", key: "doctor_name"},
                {title: "预约状态", key: "status_name"},

            ];
            if (this.status == 3) {
                colums_list.push({title: "会面时间",key: "last_meet_time"})
                colums_list.push({title: "完成会面时间", key: "update_date"})
            } else if (this.status == 4) {
                colums_list.push({title: "期望会面时间",key: "book_date"})
                colums_list.push({title: "中断会面时间", key: "update_date"})
            }

            let export_data = [];
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }

                let res_data = res.data;

                if (parseInt(res_data.code) != 0) {
                    this.$message.error(res_data.msg);
                    return false;
                }

                let list = res_data.data.list;

                for (let i = 0; i < list.length; i++) {

                    if (!list[i].meet_date) {
                        list[i].last_meet_time = (list[i].status > 2) ? '无' : '待定';
                    } else {
                        list[i].last_meet_time = list[i].meet_date + ' ' + list[i].meet_time;
                    }
                    if (list[i].address_id < 1) {
                        list[i].address_info = (list[i].status > 2) ? '无' : '待定';
                    } else {
                        list[i].address_info = list[i].region_name + list[i].address;
                    }
                    list[i].book_date = `${list[i].book_date} ${list[i].half}`

                    let status;
                    switch (list[i].status) {
                        case '3':
                            status = '会面完成';
                            break;
                        case '4':
                            status = '会面中断';
                            break;
                    }

                    let item = {
                        user_name: list[i].user_name,
                        doctor_name: list[i].doctor_name,
                        status_name: status,
                        update_date: list[i].update_date,
                    };

                    if (this.status == 3) {
                        item['last_meet_time'] = list[i].last_meet_time
                        // item.push({last_meet_time: list[i].last_meet_time})
                    } else if (this.status == 4) {
                        item['book_date'] = list[i].book_date
                        // item.push({book_date: list[i].book_date})
                    }

                    export_data.push(item);
                }
                export2Excel(colums_list, export_data, "导出预约报表");
            });
        },
    }
};
</script>
<style lang="scss">
@import "@/styles/common.scss";
.docker_buttons {
    float: right;
    margin: 30px 0px 8px 0px;

    .el-button {
        width: 150px;
        height: 32px;
        line-height: 7px;
    }
}
.el-col{
    margin-bottom: 10px;
    input{
        width: 100%;
    }
}
.inputs .el-input {width: 100% !important;}
</style>
